import script from "./FetchBitpandaUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./FetchBitpandaUser.vue?vue&type=script&lang=ts&setup=true"

import "./FetchBitpandaUser.vue?vue&type=style&index=0&id=1f770701&lang=scss"

const __exports__ = script;

export default __exports__